import React, { useState } from 'react';
import { CheckboxField } from '@trp-beacon-ui-kit/react-controls';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import TaxpayerCertificationsModal from '../TaxpayerCertificationsModal/TaxpayerCertificationsModal';
import { modalOpenHandler } from '../Modal/utils';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const TaxpayerCertificationsRenderer = ({ formProps }) => {
  const [checkboxStatus, toggleCheckboxStatus] = useState(false);

  return (
    <div className="terms">
      <p>III. Taxpayer Certifications</p>
      <p>
        By clicking on &quot;Submit&quot; below, under penalties of perjury, I
        certify that:
      </p>
      <ol>
        <li>
          The number I have entered is my correct taxpayer identification
          number; AND
        </li>
        <li>I am not subject to backup withholding because:</li>
        <ol>
          <li type="a">I am exempt from backup withholding; OR</li>
          <li type="a">
            I have not been notified by the Internal Revenue Service (IRS) that
            I am subject to backup withholding as a result of a failure to
            report all interest and dividends; OR
          </li>
          <li type="a">
            The IRS has notified me that I am no longer subject to backup
            withholding.
          </li>
        </ol>
        <li>
          I am a U.S. citizen or other U.S. person (as defined in the IRS Form
          W-9 instructions).
        </li>
      </ol>
      <MFBeaconButton
        id="subjectToBackupWithholdingBtn"
        data-name={generateGeneralTestID('Review', 'SubjectToWithholding')}
        onClick={() => modalOpenHandler('taxCertificationModal')}
        variant="tertiary"
        label="Click here ONLY if you have been notified by the IRS that you are
        subject to backup withholding because you have failed to report all
        interest and dividends on your tax returns."
      />
      {checkboxStatus && (
        <CheckboxField
          title="I acknowledge that I am subject to backup withholding on all future distributions."
          checked={checkboxStatus}
          onClick={() => toggleCheckboxStatus(!checkboxStatus)}
          {...formProps.eligibleForTaxWithholding}
          data-name={generateGeneralTestID(
            'Review',
            'EligibleForTaxWithholding'
          )}
        />
      )}
      <p>
        If I fail to give the correct number and provide certification by
        clicking &quot;Submit&quot; below, then T. Rowe Price may reject,
        restrict, or redeem my account. I may also be subject to backup
        withholding, and I may be subject to an IRS penalty. For clarification
        on any of these certification issues, please contact a T. Rowe Price
        associate at (800) 225-5132.
      </p>
      <p>
        The IRS does not require your consent to any provision of this document
        other than the certifications required to avoid backup withholding.
      </p>
      <TaxpayerCertificationsModal
        toggleCheckboxStatus={toggleCheckboxStatus}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default TaxpayerCertificationsRenderer;
